import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const BumdesSidebarLinks = ({ authUser, isCollapsed }) => {
  const location = useLocation();
  const isBumdesProgram = !!authUser?.activeSession?.isProgram;
  const isClassified = !!authUser?.activeSession?.isClassified;
  const isPreSurveyDone = !!authUser?.activeSession?.isPreSurveyDone;

  const isPreSurveyDisabled = false; // Always accessible
  const isVeciDisabled = !isPreSurveyDone; // Locked until Pre-Survey is done

  return (
    <>
      {/* Dashboard */}
      <NavLink
        to='/bumdes/home'
        className={() => {
          const isDashboardActive =
            location.pathname === '/bumdes/home' ||
            location.pathname === '/bumdes' ||
            location.pathname === '/bumdes/';
          return isDashboardActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Dashboard' : ''}
      >
        <i className='bi bi-house-fill'></i>
        <span className='sidebar-collapsed-text'>Dashboard</span>
      </NavLink>

      {/* Pre-Survey */}
      <NavLink
        to={!isPreSurveyDisabled ? '/bumdes/pre-survey' : '#'}
        onClick={(e) => {
          if (isPreSurveyDisabled) {
            e.preventDefault();
          }
        }}
        className={({ isActive }) =>
          isPreSurveyDisabled
            ? 'sidebar-link text-decoration-none text-muted opacity-50 pe-none'
            : isActive
              ? 'sidebar-link active text-decoration-none'
              : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Pre-Survey' : ''}
      >
        <i className='bi bi-patch-question-fill'></i>
        <span className='sidebar-collapsed-text'>Pre-Survey</span>
      </NavLink>

      {/* Survey VECI */}
      <NavLink
        to={!isVeciDisabled ? '/bumdes/veci' : '#'}
        onClick={(e) => {
          if (isVeciDisabled) {
            e.preventDefault();
          }
        }}
        className={({ isActive }) =>
          isVeciDisabled
            ? 'sidebar-link text-decoration-none text-muted opacity-50 pe-none'
            : isActive
              ? 'sidebar-link active text-decoration-none'
              : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Survei VECI' : ''}
      >
        <i className='bi bi-clipboard-data-fill'></i>
        <span className='sidebar-collapsed-text'>Survey VECI</span>
      </NavLink>

      {/* BMC */}
      {isBumdesProgram && isClassified && (
        <NavLink
          to='/bumdes/bmc'
          className={({ isActive }) =>
            isActive
              ? 'sidebar-link active text-decoration-none'
              : 'sidebar-link link-body-emphasis text-decoration-none'
          }
          title={isCollapsed ? 'BMC' : ''}
        >
          <i className='bi bi-grid-3x3-gap-fill'></i>
          <span className='sidebar-collapsed-text'>BMC</span>
        </NavLink>
      )}
    </>
  );
};

export default BumdesSidebarLinks;
